import React, { useId } from 'react';

import { InputLabel } from '@mui/material';
import { AlineInput } from 'src/AlineInput';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  label: {
    ...theme.appTypography.fieldLabel,
    marginBottom: theme.spacing(1),
  },
}));

export interface RoleTextInputProps {
  onChange: (value: string) => void;
  value: string | null;
  className?: string;
  dataCy?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  label?: string;
  placeholder?: string;
}

export function RoleTextInput({
  className,
  dataCy,
  disabled = false,
  fullWidth = true,
  label = 'Role',
  onChange,
  placeholder = 'Enter role name...',
  value,
}: RoleTextInputProps): JSX.Element {
  const { classes } = useStyles();
  const inputId = useId();

  return (
    <div className={className}>
      <InputLabel className={classes.label} htmlFor={inputId}>
        {label}
      </InputLabel>
      <AlineInput
        hideHelperText
        dataCy={dataCy}
        disabled={disabled}
        fullWidth={fullWidth}
        id={inputId}
        placeholder={placeholder}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}
